import type { ReactNode } from "react";
import { toast as sonnerToast } from "sonner";
import { Alert } from "@/components/alert";

const show = (message: ReactNode, type: "general" | "error" = "general") =>
  sonnerToast.custom(() => (
    <Alert type={type} className="w-360">
      {message}
    </Alert>
  ));

export const toast = {
  show: (message: ReactNode) => show(message, "general"),
  error: (message: ReactNode) => show(message, "error"),
};
